<template>
  <div class="container-main">
    <bannerVideo bg="#949590" videoUrl="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/videos/libu.mp4" allVideoUrl="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/videos/libu-all.mp4" title="励步" message="创新推出线上线下、同班同伴学习模式，以培养语言、跨学科应用能力和核心素养为目标，为孩子提供完整学习解决方案。"></bannerVideo>
    <outboxCon bg="#F8F9FD">
        <div class="my-production">
          <header>我们的学习理念</header>
          <div class="content">
            <img :src="ideaImg" alt="">
          </div>
        </div>
    </outboxCon>
    <outboxCon bg="#fff">
        <div class="choice-me">
          <header>励步的产品体系</header>
          <div class="content">
            <img :src="systemImg" alt="">
          </div>
        </div>
    </outboxCon>
    <outboxCon bg="#F8F9FD">
        <div class="my-content">
          <header>我们的产品亮点</header>
          <ul>
            <li
              v-for="item in highlightsList"
              :key="item.content1"
              :style="{'backgroundColor': item.bg}">
              <p>{{ item.content1 }}</p>
              <p>{{ item.content2 }}</p>
            </li>
          </ul>
        </div>
    </outboxCon>
  </div>
</template>
<script>
import bannerVideo from './components/bannerVideo/bannerVideo'
export default {
  data () {
    return {
      ideaImg: require('@/assets/coursetype/libu/idea.png'),
      systemImg: require('@/assets/coursetype/libu/system.png'),
      highlightsList: [
        {
          bg: '#69C8FF',
          content1: '十年教学沉淀',
          content2: '自有版权教材'
        },
        {
          bg: '#4F89FF',
          content1: '线上线下结合',
          content2: '完整学习路径'
        },
        {
          bg: '#FF4F4F',
          content1: '语言综合素养',
          content2: '全面培训目标'
        },
        {
          bg: '#FF8E18',
          content1: '创设情境学习',
          content2: '轻松迁移应用'
        },
      ]
    }
  },
  components: { bannerVideo },
  mounted() {
    document.documentElement.scrollTo(0,0)
  }
}
</script>

<style lang="scss" scoped>
.my-production,
.choice-me,
.my-content {
  width: $main-width;
  margin: 0 auto;
  padding: 50px 0px 95px 0px;
  position: relative;
  header {
    height: 56px;
    font-size: 40px;
    font-weight: 500;
    color: #282828;
    line-height: 56px;
  }
  .content {
    img {
      width: 1280px;
    }
  }
}

.my-content {
  padding: 54px 58px 260px;
  ul {
    padding-top: 136px;
    padding-inline-start: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    li {
      padding-top: 135px;
      width: 270px;
      height: 340px;
      box-shadow: 0px 10px 16px 0px rgba(0, 0, 0, 0.06);
      border-radius: 16px;
      p {
        font-size: 26px;
        font-family: FZLTDHJW--GB1-0, FZLTDHJW--GB1;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 38px;
      }
    }
  }
}
</style>
